import BankIconImg from './bank_icon.svg';

type ImageProps = React.JSX.IntrinsicElements['div'] & {
  width?: string;
  alt?: string;
}

export const BankIcon = ({width = "32px", alt = "Bank icon", ...props}: ImageProps) => <div {...props}><img src={BankIconImg} width={width} alt={alt} /></div>
export default BankIcon;